import "../../css/navbar.css";
import "../../css/fonts.css";
import { Link } from "react-router-dom";
// import { useHoverSound } from "../../hooks/useHooverSound";
// import hoverSound from "../../assets/audio/clicksoft.wav";
// import clickSound from "../../assets/audio/clickwet.wav";
// import { useIsMobile } from "../../hooks/is.mobile";
interface Props {
  onClick?: () => void;
}

export const NavbarLinks: React.FC<Props> = ({ onClick }) => {
  // const isMobile = useIsMobile();
  // const { audioElement: audio1, playSound: playSound1 } = useHoverSound(
  //   hoverSound,
  //   0.5
  // );
  // const { audioElement: audio2, playSound: playSound2 } = useHoverSound(
  //   clickSound,
  //   1
  // );
  return (
    <div>
      {/* {audio1}
      {audio2} */}
      <ul className="navbar-links">
        <li
          // onMouseEnter={() => {
          //   if (!isMobile) playSound1();
          // }}
          onClick={() => {
            if (onClick) onClick();
            // playSound2();
          }}
          className="title-text-font"
        >
          <Link to="/">Home</Link>
        </li>
        <li
          // onMouseEnter={() => {
          //   if (!isMobile) playSound1();
          // }}
          onClick={() => {
            if (onClick) onClick();
            // playSound2();
          }}
          className="title-text-font"
        >
          <Link to="/news">News</Link>
        </li>
        <li
          // onMouseEnter={() => {
          //   if (!isMobile) playSound1();
          // }}
          onClick={() => {
            if (onClick) onClick();
            // playSound2();
          }}
          className="title-text-font"
        >
          <Link to="/services">Our Services</Link>
        </li>
        <li
          // onMouseEnter={() => {
          //   if (!isMobile) playSound1();
          // }}
          onClick={() => {
            if (onClick) onClick();
            // playSound2();
          }}
          className="title-text-font"
        >
          <Link to="/about">About Us</Link>
        </li>
        <li
          // onMouseEnter={() => {
          //   if (!isMobile) playSound1();
          // }}
          onClick={() => {
            if (onClick) onClick();
            // playSound2();
          }}
          className="title-text-font"
        >
          <Link to="/contact">Contact</Link>
        </li>
      </ul>
    </div>
  );
};
